import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=fcdb8574&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=fcdb8574&prod&scoped=true&lang=css&"
import style1 from "./Base.vue?vue&type=style&index=1&id=fcdb8574&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb8574",
  null
  
)

export default component.exports